


import { IRouteConfigSettings } from '../../interface/config';
import { IRoute } from '../../interface/route';
import { IQueryURL } from '../../interface/util';
import component from './component';
import { IRouteLanguageSelect } from './interface';
import coordinator from './coordinator';


function route(settings: IRouteConfigSettings, query: IQueryURL): IRoute<IRouteLanguageSelect> {
    const route: IRoute<IRouteLanguageSelect> = {
        paths: [settings.pathPrefix, ...settings.pathMatch.splice(1)],
        push: (history, props) => coordinator.push(settings, query, history, props),
        replace: (history, props) => coordinator.replace(settings, query, history, props),
        component: component,
    }    

    return route;
}

export default route;